import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NODE_TYPES } from "constants/flowDesigner";

import { setNumberOfNodesLimitReached } from "redux/actions/flowDesigner/flowsActionCreator";
import { getEnv } from "helpers/environment";

const useLimitNumberOfNode = () => {
  const [allowedNumberOfNodes, setAllowedNumberOfNodes] = useState(getEnv("MAX_NUMBER_OF_NODES"));
  const { tenantData } = useSelector((store) => store.designer.tenant);
  const rDispatch = useDispatch();

  const checkIsAllowAddNode = (existingNodes = []) => {
    const withoutStaticNodes = existingNodes.filter(
      (node) =>
        !(node.type === NODE_TYPES.STATIC) &&
        !(node.type === NODE_TYPES.LABEL) &&
        !(node.type === NODE_TYPES.HIDDEN)
    );

    if (withoutStaticNodes.length < allowedNumberOfNodes) {
      return true;
    } else {
      rDispatch(setNumberOfNodesLimitReached(true)); // open number of nodes limit reached alert dialog
      return false;
    }
  };

  useEffect(() => {
    // Set the allowed number of nodes from tenant data config
    if (tenantData?.config) {
      try {
        const parsedTenantDataConfig = JSON.parse(tenantData.config);
        const tenantDataConfigMaxNumberOfNodes =
          parsedTenantDataConfig.max_number_of_nodes || getEnv("MAX_NUMBER_OF_NODES");
        setAllowedNumberOfNodes(tenantDataConfigMaxNumberOfNodes);
      } catch (error) {
        setAllowedNumberOfNodes(getEnv("MAX_NUMBER_OF_NODES"));
      }
    }
  }, [tenantData]);

  return { checkIsAllowAddNode };
};

export default useLimitNumberOfNode;
